import React from "react";
import { useDispatch, useSelector } from "react-redux";
import NavButton from "./buttons/NavButton";
import C from "../constants";

const AlertDialog = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(state => state.alertDialog ? state.alertDialog.open : false);
    const isLoading = useSelector(state => state.isLoading);
    const alertText = useSelector(state => state.alertDialog ? state.alertDialog.text : "");

    if (isLoading || !isOpen) {
        return null;
    }

    return (
            <dialog open className="w3-display-middle w3-white w3-border w3-animate-opacity w3-padding-large">
            <p className="w3-container w3-margin">{alertText}</p>
            <NavButton onClick={() => dispatch({type: C.HIDE_DIALOG})} text="OK" />
            </dialog>
    );
};

export default AlertDialog;
